export default __webpack_public_path__ + "static/media/Logo.03065b69.svg";